import { postMagicLoginUrl } from 'api/v3/access/accountantsAuth';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';

const useExpertSendMagicLink: any = () => {
  const navigate = useNavigate();

  return useMutation(postMagicLoginUrl, {
    onSuccess: (_, { email }) => {
      navigate(`/login?state=sent&email=${encodeURIComponent(email)}`);
    },
  });
};

export default useExpertSendMagicLink;
